import SwitchTabs from '@gr-monorepo/common/ui/SwitchTabs';
export * from '@gr-monorepo/common/ui/SwitchTabs';
export * from './CustomTabs';

export default SwitchTabs;
